const SERVED_CUSTOMER_KEY = "cod.servedCustomer";

export interface StoredServedCustomer {
  id: string;
  customerCode: string;
  customerName: string;
  customerCategory?: string;
  currency?: string;
  addressDescription1?: string;
  addressDescription2?: string;
  statGroup3Description?: string;
  mobileNumber?: string;
  onlineShipmentSite?: string;
}

export const loadServedCustomer = (): StoredServedCustomer | null => {
  try {
    const raw = sessionStorage.getItem(SERVED_CUSTOMER_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredServedCustomer;
    return parsed?.id ? parsed : null;
  } catch {
    return null;
  }
};

export const saveServedCustomer = (customer: StoredServedCustomer | null) => {
  if (!customer?.id) {
    sessionStorage.removeItem(SERVED_CUSTOMER_KEY);
    return;
  }
  sessionStorage.setItem(SERVED_CUSTOMER_KEY, JSON.stringify(customer));
};

export const clearServedCustomer = () => {
  sessionStorage.removeItem(SERVED_CUSTOMER_KEY);
};
